import { defineContract } from "../defineContract";
import { SOCKET_EVENTS } from "../socketEvents";

/** Payload de SOCKET_EVENTS.PLAN.UPDATED — CompanyController.update (troca de plano). */
export interface PlanEventPayload {
  action: "update";
}

export const planCompanyContract = defineContract<void, unknown, PlanEventPayload>({
  route: "/companies/listPlan/:id",
  buildRoute: (id: number | string) => `/companies/listPlan/${id}`,
  method: "GET",
  events: { changed: SOCKET_EVENTS.PLAN.UPDATED },
  cache: { ttl: 5 * 60 * 1000, invalidatedBy: ["changed"] }
});
